import React from "react";
import { useParams } from "react-router-dom";
import moment from "moment-timezone";

import Loading from "ui/Loading";
import PageContent from "ui/PageContent";
import Panel from "ui/Panel";
import PanelSection from "ui/PanelSection";
import PanelTable from "ui/PanelTable";
import { useSnapshotDetailsQuery } from "./gql/Query.generated";

const SnapshotDetails: React.FunctionComponent = () => {
  const params = useParams();
  const collectedAt = Number(params.collectedAt);
  const { data, loading, error } = useSnapshotDetailsQuery({
    variables: {
      serverId: params.serverId,
      collectedAt,
      kind: "full",
    },
  });
  if (loading || error) {
    return <Loading error={!!error} />;
  }
  const { submitter, hasError, errorMessage, systemJson } =
    data.getSnapshotDetails;
  return (
    <PageContent title="Snapshot" pageCategory="snapshots" pageName="show">
      <Panel title="Overview">
        <PanelTable horizontal>
          <tbody>
            <tr>
              <th>Collected At</th>
              <td>{moment.unix(collectedAt).format("MMM DD hh:mm:ssa zz")}</td>
              <th>Submitter</th>
              <td>{submitter}</td>
            </tr>
          </tbody>
        </PanelTable>
      </Panel>
      {hasError && errorMessage && (
        <Panel title="Collector Error">
          <PanelSection>
            <p>
              This snapshot could not be collected on your system due to an
              error:
            </p>
            <pre>{errorMessage}</pre>
          </PanelSection>
          <PanelSection>
            <p>
              <strong>Hint:</strong> You can use the --test option of the
              collector to test your configuration.
            </p>
          </PanelSection>
        </Panel>
      )}
      {hasError && !errorMessage && (
        <Panel title="Internal Error">
          <PanelSection>
            <p>
              This snapshot could not be processed due to an internal error.
            </p>
            <p>Please contact support for assistance.</p>
          </PanelSection>
        </Panel>
      )}
      <Panel title="System">
        <PanelSection>
          <pre>{JSON.stringify(systemJson, null, 2)}</pre>
        </PanelSection>
      </Panel>
    </PageContent>
  );
};

export default SnapshotDetails;
